/**
 * utils/filenameNormalizer.ts
 *
 * Utility for generating normalized PDF filenames in the format:
 * "intitule-du-document-nom-prenom.pdf"
 *
 * Used by the ClientDocumentsTab to display computed display_filename values.
 * A mirror of this logic lives in the convert-documents Edge Function (Deno).
 *
 * Created Mar 2026: PDF conversion and intelligent renaming feature.
 */

export function slugify(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-');
}

export interface FilenameParams {
  documentLabel: string;
  lastName: string | null;
  firstName: string | null;
  index?: number;
}

export function buildDisplayFilename({
  documentLabel,
  lastName,
  firstName,
  index,
}: FilenameParams): string {
  const docSlug = slugify(documentLabel) || 'document';

  const nameParts: string[] = [];
  if (lastName) nameParts.push(slugify(lastName));
  if (firstName) nameParts.push(slugify(firstName));
  const nameSlug = nameParts.filter(Boolean).join('-') || 'client';

  const suffix = index && index > 1 ? `-${index}` : '';
  return `${docSlug}-${nameSlug}${suffix}.pdf`;
}
